import { render, staticRenderFns } from "./IconPost.vue?vue&type=template&id=5635514c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5635514c')) {
      api.createRecord('5635514c', component.options)
    } else {
      api.reload('5635514c', component.options)
    }
    module.hot.accept("./IconPost.vue?vue&type=template&id=5635514c&", function () {
      api.rerender('5635514c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/IconPost.vue"
export default component.exports